import React from 'react';
import clsx from 'clsx'

import Paragraph from '../../atoms/Paragraph/Paragraph'
import { numberToDisplayString } from '../../../common/helpers/number.helpers'
import { monthsAmountDisplayedNames } from '../../../common/helpers/helpers'
import { APP_COLOR, APP_FONT_SIZE } from '../../atoms/AtomsGlobalProps'
import { LoanOfferSummaryShortPanelProps } from './LoanOfferSummaryPanelShortProps'
import AppButton from '../../atoms/AppButton/AppButton'
import { UI_BUTTON_TYPE } from '../../atoms/AppButton/AppButtonProps'


import './LoanOfferSummaryPanelShortStyles.scss'


/**
 * MOLEKUŁA - Panel z podsumowaniem oferty w dwóch wariantach: tylko od odczytu oraz do edycji.
 * >>> Wariant TYLKO DO ODCZYTU korzysta z WYBRANEJ OFERTY a nie ze wstępnej, stąd w procesie pojawia się po kroku wyboru oferty.
 * >>> Wariant DO EDYCJI posiada przycisk, pozwalajacy na rozwinięcie kalkulatora i zmianę parametrów oferty. Działa on na PRE OFERCIE, nie na faktycznie wybranej
 * @returns 
 */
const LoanOfferSummaryPanelShort = (props: LoanOfferSummaryShortPanelProps) => {
   const { handleOnOpen, requestedAmount, instalments, instalmentAmount, className, readOnly = false } = props   

   if(requestedAmount === undefined || instalments === undefined || instalmentAmount === undefined) {
      console.error("Brak wymaganych parametrów oferty. Nie można wyświetlić panelu podsumowania oferty.")
      return null
   }


   return (
      <section className={clsx('loan-calculator-short-panel-wrapper', className)} aria-labelledby='loan-calculator-short-summary-heading'>
         <h2 id="loan-calculator-short-summary-heading" className='loan-calculator-short-panel-label--visually-hidden'>
            Panel z podsumowaniem wybranej pożyczki
         </h2>
         <div className={clsx('loan-calculator-short-panel-items-outer-wrapper', { 'short-panel-items-outer-wrapper--read-only-panel': readOnly })}>
            <div className='loan-calculator-short-panel-item-wrapper'>
               <h6>Kwota</h6>
               <Paragraph color={APP_COLOR.SECONDARY} size={APP_FONT_SIZE.SMALL}>
                  {numberToDisplayString(requestedAmount, " zł")}
               </Paragraph>
            </div>
            <div className='loan-calculator-short-panel-item-wrapper'>
               <h6>Okres</h6>
               <Paragraph color={APP_COLOR.SECONDARY} size={APP_FONT_SIZE.SMALL}>
                  {monthsAmountDisplayedNames(instalments)}
               </Paragraph>
            </div>
            <div className='loan-calculator-short-panel-item-wrapper'>
               <h6>Rata</h6>
               <Paragraph color={APP_COLOR.SECONDARY} size={APP_FONT_SIZE.SMALL}>
                  {numberToDisplayString(instalmentAmount, " zł")}
               </Paragraph>
            </div>
         </div>
         {
            !readOnly && (
               <AppButton onClick={handleOnOpen} uiButtonType={UI_BUTTON_TYPE.SECONDARY_DARKEN} className='loan-calculator-short-panel-expand-button'>
                  Zmień
               </AppButton>
            )
         }
      </section>
   )
}

export default LoanOfferSummaryPanelShort